module.exports = __webpack_public_path__ + "img/06.4b52fc2f.png";